import React from 'react'

export default function JobsPage () {
  return (
    <div>
      <h1>JobsPage</h1>
      <p>Whant job?Get some comercial expirience</p>
    </div>
  )
}
